__turbopack_context__.v({
  "hero": "hero-module__HNXeQG__hero",
  "heroContent": "hero-module__HNXeQG__heroContent",
  "heroCountdown": "hero-module__HNXeQG__heroCountdown",
  "heroImage": "hero-module__HNXeQG__heroImage",
  "heroImageGradient": "hero-module__HNXeQG__heroImageGradient",
  "heroSubtitle": "hero-module__HNXeQG__heroSubtitle",
  "heroTitle": "hero-module__HNXeQG__heroTitle",
  "heroTitleTeal": "hero-module__HNXeQG__heroTitleTeal",
  "heroTrustpilot": "hero-module__HNXeQG__heroTrustpilot",
  "wave": "hero-module__HNXeQG__wave",
  "waveWrapper": "hero-module__HNXeQG__waveWrapper",
});
